import React from "react";

export default function FieldColor_FormValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-default ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>
                <div className={Classes("ui5-color-picker", "gd-c-"+props.option.value)}/>
            </div>
            {props.children}
        </React.Fragment>
    );
}